module.exports = __webpack_public_path__ + "img/bkl5.6334108b.jpg";